import type React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { clearEmployeeNotFoundFlag } from '../contexts/AuthContext';
import { logout } from '../utils/auth';
import { Footer } from './VersionDisplay';

export const ContactSupport: React.FC = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-surface-muted p-8">
      <Card className="w-full max-w-xl text-center">
        <CardHeader>
          <div className="mb-4 text-6xl">🔒</div>
          <CardTitle className="text-2xl">Access Restricted</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col gap-6">
          <p className="text-lg leading-relaxed text-text-secondary">
            Your account is not registered in the system. Please contact Administrator to request
            access.
          </p>

          <div className="rounded-lg bg-surface-muted p-6 text-left">
            <h2 className="mb-4 text-lg font-semibold text-text-primary">Contact Information</h2>
            <div>
              <strong className="text-text-primary">Email:</strong>
              <div className="mt-1 text-text-secondary">
                christian.miguel-langstrof@ppe-intelligence.com
              </div>
            </div>
          </div>

          <Button
            type="button"
            onClick={async () => {
              try {
                await logout();
                clearEmployeeNotFoundFlag();
                document.cookie.split(';').forEach((c) => {
                  document.cookie = c
                    .replace(/^ +/, '')
                    .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
                });
                window.location.href = '/';
              } catch {
                clearEmployeeNotFoundFlag();
                window.location.href = '/';
              }
            }}
          >
            Return to Login
          </Button>
        </CardContent>
      </Card>

      <div className="mt-8">
        <Footer />
      </div>
    </div>
  );
};
